module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "redirect_block"
  }, [_c('div', {
    staticClass: "redirect_list"
  }, _vm._l((_vm.data), function(elem) {
    return _c('div', {
      key: elem.code,
      staticClass: "redirect_block_link col-lg-4 col-md-6 col-12"
    }, [_c('router-link', {
      staticClass: "route_link",
      attrs: {
        "to": elem.url
      }
    }, [_vm._v(_vm._s(elem.name))])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c82937","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/siteNavigationList/SiteNavigationList.vue
// module id = f04774ea481f703ac5d6
// module chunks = 0